export default {
  name: 'LoaderComponent',
  props: ['absolute', 'size'],
}